/*
 * @Author: Lisisi
 * @Date: 2023-07-17 15:10:50
 * @LastEditTime: 2023-09-19 10:44:52
 * @LastEditors: your name
 * @Description:
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import Tools from "@/utils/tools";
import "element-ui/lib/theme-chalk/index.css";
import "vant/lib/index.css";

import Vant from "vant";
import "lib-flexible/flexible";
import store from "./store/store";

import moment from "moment";
Vue.filter("dateFormat", function(dateStr, pattern = "YYYY-MM-DD") {
  return moment(dateStr).format(pattern);
});

import VueCookies from "vue-cookies";
Vue.use(VueCookies);
Vue.filter("NumFormat", function(value) {
  if (!value) return "0";
  var intPart = Number(value).toFixed(0); // 获取整数部分
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); // 将整数部分逢三一断
  return intPartFormat;
});
Vue.filter("Percent", function(value) {
  if (!value) return "0";
  var percentInt = Math.round(value * 1000) / 10;
  return percentInt.toFixed(1);
});

Vue.filter("Zheng", function(value) {
  if (!value) return "-";
  var percentInt = Math.round(value * 1000) / 10;
  if (percentInt > 0) {
    return "+" + percentInt.toFixed(1) + "%";
  } else {
    return percentInt.toFixed(1) + "%";
  }
});
Vue.filter("Zheng2", function(value) {
  if (!value) return "0";
  var percentInt = Math.round(value * 1000) / 10;
  if (percentInt > 0) {
    return "+" + percentInt.toFixed(1);
  } else {
    return percentInt.toFixed(1);
  }
});
import axios from "axios";
Vue.prototype.$http = axios;

import echarts from "echarts";
Vue.prototype.$echarts = echarts;

//axios.defaults.baseURL = "https://mbqa.kenvue.com.cn/mobile_api/";
axios.defaults.baseURL = "https://mb.kenvue.com.cn/mobile_api/";
//axios.defaults.baseURL = "http://localhost:8081/mobile_api/";
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8e";
Vue.prototype.$addr = axios;

Vue.use(Vant);
Vue.use(ElementUI);
Vue.prototype.fontSize = Tools.fontSize;

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js